<template>
  <transition>
    <button class="scroll-to-top-button" v-if="showScrollButton" id="ScrollButton" @click="scrollToTop">
      <i class="fas fa-angle-up fa-lg" @click="scrollToTop" style="color: #fdfdff;"></i>
    </button>
  </transition>
</template>

<script>
import { ref, onMounted } from "vue";

export default {
  setup() {
    const showScrollButton = ref(false);

    const scrollToTop = () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const handleScroll = () => {
      const screenHeight = window.innerHeight / 2;
      showScrollButton.value = window.pageYOffset > screenHeight;
    };

    onMounted(() => {
      window.addEventListener('scroll', handleScroll);
    });

    return {
      showScrollButton,
      scrollToTop,
    };
  },
};
</script>



<style scoped>
.fas {
  height: 200px;
}

.scroll-to-top-button {
  position: fixed;
  bottom: 60px;
  right: 20px;
  background: linear-gradient(to right, #6f42c1 0%, #00bcd4 30%, #e83e8c 51%, #6f42c1 100%);
  border-radius: 50%;
  border: none;
  width: 40px;
  height: 40px;
  outline: none;
  cursor: pointer;
  box-shadow: 0 0 20px #1B1C1E50;
  background-size: 400% auto;
  display: flex;
  justify-content: center;
  align-items: center;
  animation: Button .2s ease-out;
  transition: all .3s ease-in-out;
}

.scroll-to-top-button:hover {
  background-position: right center;
}

.v-enter-from {
  transform: scale(0);
}

.v-enter-active {
  transition: all .2s ease-out;
}

.v-enter-to {
  transform: scale(1);
}

.v-leave-from {
  transform: scale(1);
  }

.v-leave-active {
  transition: all .2s ease-out;
}

.v-leave-to {
  transform: scale(0);
}
</style>